// SPDX-License-Identifier: AGPL-3.0-or-later
export const APP_PROTOCOL = 'fluxer';
export const APP_PROTOCOL_PREFIX = `${APP_PROTOCOL}://`;
export function buildAppProtocolUrl(path: string): string {
	const cleaned = path.replace(/^\/+/, '');
	return `${APP_PROTOCOL_PREFIX}${cleaned}`;
}
